export default "__VITE_ASSET__SoVSoV8M__"